import { CheckTicketPusatResolusiRequest, GetConversationRequest, ListSTTPusatResolusi, ListTicketPusatResolusiRequest, TicketCounterPusatResolusiRequest } from "@/data/payload/api/PusatResolusiV2ApiRequest";

export class PusatResolusiV2Endpoint {
  checkTicket(params: CheckTicketPusatResolusiRequest): string {
    return `athena/v1/ticket/check?${params.toQueryString()}`;
  }
  getListCategory(params: CheckTicketPusatResolusiRequest): string {
    return `athena/v1/category?${params.toQueryString()}`;
  }
  getTicketCounter(params: TicketCounterPusatResolusiRequest): string {
    return `athena/v1/ticket/summary?${params.toQueryString()}`;
  }
  getTicketList(params: ListTicketPusatResolusiRequest): string {
    return `athena/v1/ticket?${params.toQueryString()}`;
  }
  getSTTList(params: ListSTTPusatResolusi): string {
    return `/athena/v1/stt/issue?${params.toQueryString()}`;
  }
  checkIssue(params: CheckTicketPusatResolusiRequest) {
    return `athena/v1/ticket/check?${params.toQueryString()}`;
  }
  followTicket(id: number) {
    return `/athena/v1/ticket/${id}/follow`;
  }
  getTicketDetail(id: number) {
    return `/athena/v1/ticket/${id}`;
  }
  getTicketAction(id: number) {
    return `/athena/v1/ticket/${id}/action`;
  }
  submitNote(id: number) {
    return `/athena/v1/ticket/${id}/note`;
  }
  create(): string {
    return "athena/v1/ticket";
  }
  finishIssue(id: number) {
    return `/athena/v1/ticket/${id}/finish`;
  }
  getConversation(id: number, params: GetConversationRequest): string {
    return `/athena/v1/ticket/${id}/conversation?${params.toQueryString()}`;
  }
  getMention(id: number) {
    return `/athena/v1/ticket/${id}/mention`;
  }
  sendChat(id: number) {
    return `/athena/v1/ticket/${id}/conversation`;
  }
}
